import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "vh-100 d-flex justify-content-center align-items-center"
}
const _hoisted_2 = {
  key: 1,
  class: "user-form email-setts"
}
const _hoisted_3 = { class: "user-form profile-form" }
const _hoisted_4 = { class: "row h2" }
const _hoisted_5 = { class: "col-md-6 col-sm-12" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-bookmarks-fill" }, null, -1)
const _hoisted_7 = { class: "d-flex justify-content-end col-md-6 col-sm-12" }
const _hoisted_8 = ["placeholder"]
const _hoisted_9 = { class: "small-fs-1" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-caret-left-fill" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "clearboth" }, null, -1)
const _hoisted_13 = { class: "setting-data" }
const _hoisted_14 = { class: "row align-items-center" }
const _hoisted_15 = { class: "col-md-6 col-sm-12 mb-0" }
const _hoisted_16 = { class: "col-md-6 col-sm-12 d-flex justify-content-end" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = { class: "table" }
const _hoisted_19 = { class: "d-block d-md-none" }
const _hoisted_20 = { class: "d-block my-3" }
const _hoisted_21 = { class: "d-none d-md-block" }
const _hoisted_22 = { class: "d-none t-d-md-table-cell" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("th", { class: "d-none t-d-md-table-cell" }, null, -1)
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { colspan: "3" }
const _hoisted_26 = { class: "text-center py-2" }
const _hoisted_27 = {
  "show-md": "",
  "show-lg": "",
  "hide-sm": "",
  "hide-xs": "",
  class: "d-none d-md-block"
}
const _hoisted_28 = ["onClick"]
const _hoisted_29 = {
  "show-sm": "",
  "show-xs": "",
  "hide-md": "",
  "hide-lg": "",
  class: "d-block d-md-none",
  style: {"position":"relative"}
}
const _hoisted_30 = { style: {"padding":"5px 0"} }
const _hoisted_31 = { class: "bold" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { style: {"padding":"5px 0"} }
const _hoisted_34 = { class: "bold" }
const _hoisted_35 = { class: "discl-menu dropdown pos-abs-top-right not-large" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("a", {
  href: "javascript:;",
  class: "discl-menu-caret dropdown-toggle",
  id: "dropBrok1",
  "data-bs-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}, null, -1)
const _hoisted_37 = {
  class: "dropdown-menu dropdown-menu-right",
  "aria-labelledby": "dropBrok1"
}
const _hoisted_38 = ["onClick"]
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { class: "d-none t-d-md-table-cell" }
const _hoisted_41 = { class: "d-none t-d-md-table-cell" }
const _hoisted_42 = { class: "sett-small-menu align-right" }
const _hoisted_43 = { class: "discl-menu dropdown" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("a", {
  class: "discl-menu-caret dropdown-toggle",
  href: "javascript:void(0)",
  role: "button",
  id: "dropdownMenuLink",
  "data-bs-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}, null, -1)
const _hoisted_45 = {
  class: "dropdown-menu dropdown-menu-right",
  "aria-labelledby": "dropdownMenuLink"
}
const _hoisted_46 = ["onClick"]
const _hoisted_47 = ["onClick"]
const _hoisted_48 = { class: "col-md-6 col-sm-12" }
const _hoisted_49 = { class: "area-info" }
const _hoisted_50 = { class: "col-md-6 col-sm-12" }
const _hoisted_51 = { class: "d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_jw_pager = _resolveComponent("jw-pager")!
  const _component_printer_dialog = _resolveComponent("printer-dialog")!
  const _component_SubCategoryModal = _resolveComponent("SubCategoryModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isStillLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_font_awesome_icon, {
            icon: ['fa', 'fa-spinner'],
            class: "fs-1"
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("form", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createTextVNode("  " + _toDisplayString(_ctx.language.sub_categories), 1)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control input-sm",
                    placeholder: _ctx.language.search.toLowerCase(),
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.subCategSearchKey) = $event))
                  }, null, 8, _hoisted_8), [
                    [_vModelText, _ctx.subCategSearchKey]
                  ])
                ])
              ])
            ]),
            _createElementVNode("p", _hoisted_9, [
              (!_ctx.relatedCategory.bReady)
                ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                    key: 0,
                    icon: ['fa', 'fa-spinner']
                  }))
                : (_openBlock(), _createElementBlock("span", _hoisted_10, [
                    _createVNode(_component_RouterLink, { to: _ctx.backToOneSpecificCateg }, {
                      default: _withCtx(() => [
                        _hoisted_11,
                        _createTextVNode("  "),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.relatedCategory.record.Code), 1),
                        _createTextVNode("  " + _toDisplayString(_ctx.getRealCategoryName(_ctx.relatedCategory.record)), 1)
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ]))
            ]),
            _createElementVNode("p", null, _toDisplayString(_ctx.language.list_of_subcategs_msg), 1),
            _hoisted_12
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("h3", _hoisted_15, _toDisplayString(_ctx.language.sub_categories), 1),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", null, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn-xs",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showAddSubCategAction(0, null)))
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'plus'] }),
                    _createTextVNode("  " + _toDisplayString(_ctx.language.new), 1)
                  ]),
                  _createTextVNode("  "),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn-xs",
                    disabled: _ctx.listOfSubCategs.length == 0,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.printListItems()))
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'print'] }),
                    _createTextVNode("  " + _toDisplayString(_ctx.language.print), 1)
                  ], 8, _hoisted_17),
                  _createTextVNode("  "),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn-xs",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.refreshList()))
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'refresh'] }),
                    _createTextVNode("  " + _toDisplayString(_ctx.language.refresh), 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("table", _hoisted_18, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, [
                    _createElementVNode("span", _hoisted_19, [
                      _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.language.sub_categories), 1)
                    ]),
                    _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.language.code), 1)
                  ]),
                  _createElementVNode("th", _hoisted_22, _toDisplayString(_ctx.language.name), 1),
                  _hoisted_23
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_ctx.listOfSubCategs.length == 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_24, [
                      _createElementVNode("td", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.language.no_rec_fnd), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subCategsPageElts, (recSuppl) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    class: "acct-cal-verified",
                    key: recSuppl.ProdCategoryId
                  }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_27, [
                        _createElementVNode("a", {
                          href: "javascript:;",
                          onClick: ($event: any) => (_ctx.showAddSubCategAction(1, recSuppl))
                        }, _toDisplayString(recSuppl.SubCode), 9, _hoisted_28)
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.language.code) + ": ", 1),
                          _createTextVNode("  "),
                          _createElementVNode("a", {
                            href: "javascript:;",
                            onClick: ($event: any) => (_ctx.showAddSubCategAction(1, recSuppl))
                          }, _toDisplayString(recSuppl.SubCode), 9, _hoisted_32)
                        ]),
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.language.name) + ":", 1),
                          _createTextVNode(" "),
                          _createElementVNode("span", null, _toDisplayString(_ctx.getCategoryName(recSuppl)), 1)
                        ]),
                        _createElementVNode("span", _hoisted_35, [
                          _hoisted_36,
                          _createElementVNode("div", _hoisted_37, [
                            _createElementVNode("a", {
                              class: "dropdown-item py-2",
                              href: "javascript:;",
                              onClick: ($event: any) => (_ctx.showAddSubCategAction(1, recSuppl))
                            }, [
                              _createVNode(_component_font_awesome_icon, { icon: ['fas', 'edit'] }),
                              _createTextVNode(" " + _toDisplayString(_ctx.language.edit), 1)
                            ], 8, _hoisted_38),
                            _createElementVNode("a", {
                              class: "dropdown-item py-2",
                              href: "javascript:;",
                              onClick: ($event: any) => (_ctx.deleteSubCategRecord(recSuppl))
                            }, [
                              _createVNode(_component_font_awesome_icon, { icon: ['fas', 'trash'] }),
                              _createTextVNode(" " + _toDisplayString(_ctx.language.delete), 1)
                            ], 8, _hoisted_39)
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_40, _toDisplayString(_ctx.getCategoryName(recSuppl)), 1),
                    _createElementVNode("td", _hoisted_41, [
                      _createElementVNode("div", _hoisted_42, [
                        _createElementVNode("span", _hoisted_43, [
                          _hoisted_44,
                          _createElementVNode("div", _hoisted_45, [
                            _createElementVNode("a", {
                              class: "dropdown-item py-2",
                              href: "javascript:;",
                              onClick: ($event: any) => (_ctx.showAddSubCategAction(1, recSuppl))
                            }, [
                              _createVNode(_component_font_awesome_icon, { icon: ['fa', 'fa-edit'] }),
                              _createTextVNode(" " + _toDisplayString(_ctx.language.edit), 1)
                            ], 8, _hoisted_46),
                            _createElementVNode("a", {
                              class: "dropdown-item py-2",
                              href: "javascript:;",
                              onClick: ($event: any) => (_ctx.deleteSubCategRecord(recSuppl))
                            }, [
                              _createVNode(_component_font_awesome_icon, { icon: ['fa', 'fa-trash'] }),
                              _createTextVNode("  " + _toDisplayString(_ctx.language.delete), 1)
                            ], 8, _hoisted_47)
                          ])
                        ])
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["row margin-to-15", {'d-none': _ctx.listOfSubCategs.length==0}])
            }, [
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("div", _hoisted_49, [
                  _createTextVNode(_toDisplayString(_ctx.language.total_entries) + ": ", 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.listOfSubCategs.length), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("nav", _hoisted_51, [
                  _createVNode(_component_jw_pager, {
                    items: _ctx.filteredSubCategs,
                    initialPage: 1,
                    pageSize: _ctx.itemsPerPage,
                    maxPages: 10,
                    onChangePage: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onPageChange($event)))
                  }, null, 8, ["items", "pageSize"])
                ])
              ])
            ], 2)
          ])
        ])),
    (_openBlock(), _createBlock(_Teleport, { to: "#modals-container" }, [
      _createVNode(_component_printer_dialog, {
        visible: _ctx.isPrintvisible,
        onCloseForm: _ctx.onPrintClose,
        printBaseData: _ctx.printInitialValues,
        extraPrintData: _ctx.printExtraData
      }, null, 8, ["visible", "onCloseForm", "printBaseData", "extraPrintData"]),
      _createVNode(_component_SubCategoryModal, {
        visible: _ctx.isDialogOpen,
        initialValues: _ctx.dialogRecordData,
        recordStatus: _ctx.dialogRecordStatus,
        onCloseForm: _ctx.onCloseForm
      }, null, 8, ["visible", "initialValues", "recordStatus", "onCloseForm"])
    ]))
  ], 64))
}